<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.6202 8.99C5.5902 0.330002 18.4202 0.340003 20.3802 9C21.5302 14.08 18.3702 18.38 15.6002 21.04C13.5902 22.98 10.4102 22.98 8.3902 21.04C5.6302 18.38 2.4702 14.07 3.6202 8.99Z" stroke="#302F2F" stroke-width="1.5"/>
    <path d="M9.25 12L10.75 13.5L14.75 9.5" stroke="#302F2F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
